export default __webpack_public_path__ + "static/media/grafema_gim-tonico_01.f7c65e65.jpg";